import { boolean, literal, nativeEnum, object, string, TypeOf } from 'zod';

import { Alignment, ElementType } from '../common';
import { TileOptions } from './tile';

/* ----------------------------- GridPageElement ---------------------------- */

export const GridOptions = object({
    name: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    description: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    tile: TileOptions,
});

export type GridOptions = TypeOf<typeof GridOptions>;

export const GridPageElement = GridOptions.deepPartial().extend({
    id: string(),
    type: literal(ElementType.Grid),
    collectionId: string(),
});

export type GridPageElement = TypeOf<typeof GridPageElement>;
